<template>
  <media-composition ref="mediaComp"
                     :delay="delay"
                     :controls="false"
                     :loop="loop"
                     :autoplay="autoplay"
                     :media-composition="mediaComposition"
                     :max-height="maxHeight"
                     :subtitles-default="subtitlesDefault"
                     @mediaReady="mediaReady($event)"
                     @play="playing()"
                     @pause="paused()"
                     @mediaComplete="complete($event)"
                     @eventStarted="triggerEvent('eventStarted',$event)"
                     @eventEnded="triggerEvent('eventEnded',$event)"
                     @endAllEvents="triggerEvent('endAllEvents',$event)"
                     @progress="progressUpdated($event)"
  ></media-composition>
</template>

<script>
  import ApplicationEventHub from "../../events/applicationEventHub"
  import MediaComposition from "./MediaComposition";

  export default {
    name: "MediaCompositionFramework",
    components: {
      MediaComposition
    },
    props: {
      delay : {
        default : null
      },
      mediaComposition: {
        type: Object,
        required: true
      },
      loop: {
        default: false,
        type: Boolean
      },
      autoplay: {
        default: false,
        type: Boolean
      },
      maxHeight: {
        type: String,
        default: '100%'
      },
      subtitlesDefault: {
        default: false,
      }
    },
    data() {
      return {}
    },
    methods: {
      triggerEvent(eventType,data){
        ApplicationEventHub.$emit(eventType,data);
      },
      playing(){
        this.$store.dispatch('media/playing');
      },
      paused(){
        this.$store.dispatch('media/paused');
      },
      play() {
        this.$refs.mediaComp.play();
      },
      pause() {
        this.$refs.mediaComp.pause();
      },
      stop() {
        this.$refs.mediaComp.pause();
      },
      forward(time = 5) {
        this.$refs.mediaComp.forward(time);
      },
      backward(time = 5) {
        this.$refs.mediaComp.backward(time);
      },
      setVolume(vol = 50) {
        this.$refs.mediaComp.setVolume(vol);
      },
      setSubtitles(show) {
        this.$refs.mediaComp.setSubtitles(show);
        this.$store.dispatch('media/setSubtitles',show);
      },
      registerEventHubListeners() {
        ApplicationEventHub.$on('media.play', this.play);
        ApplicationEventHub.$on('media.pause', this.pause);
        ApplicationEventHub.$on('media.stop', this.stop);
        ApplicationEventHub.$on('media.skip_forward', this.forward);
        ApplicationEventHub.$on('media.skip_backward', this.backward);
        ApplicationEventHub.$on('media.volume_changed', this.setVolume);
        ApplicationEventHub.$on('media.restart', this.restart);
        ApplicationEventHub.$on('media.show_subtitles', this.setSubtitles);
      },
      removeEventHubListeners() {
        ApplicationEventHub.$off('media.play', this.play);
        ApplicationEventHub.$off('media.pause', this.pause);
        ApplicationEventHub.$off('media.stop', this.stop);
        ApplicationEventHub.$off('media.skip_forward', this.forward);
        ApplicationEventHub.$off('media.skip_backward', this.backward);
        ApplicationEventHub.$off('media.volume_changed', this.setVolume);
        ApplicationEventHub.$off('media.restart', this.restart);
        ApplicationEventHub.$off('media.show_subtitles', this.setSubtitles);
      },
      complete(id) {
        ApplicationEventHub.$emit('media.complete', id);
        this.$store.dispatch('media/paused');
      },
      event(event) {
        ApplicationEventHub.$emit('media.event', event);
      },
      progressUpdated(progress) {
        this.$store.dispatch('media/setProgress',progress);
      },
      mediaReady() {
        this.$emit('mediaReady');
        this.$store.dispatch('media/setMediaControlsReady');
      },
      restart() {
        this.$refs.mediaComp.reset();
      },
      getCurrentTime(){
        return this.$refs.mediaComp.getCurrentTime();
      }
    },
    mounted() {
      this.registerEventHubListeners();
      this.$store.dispatch('media/setMediaControls', true);
      this.setVolume(this.$store.state.media.volume);
      this.setSubtitles(this.$store.state.media.subtitlesActive);
      if(this.mediaComposition.transcript_textassetid){
         this.$store.dispatch('media/setTranscript', this.$ta(this.mediaComposition.transcript_textassetid));
      }
      if(this.mediaComposition.subtitles && this.mediaComposition.subtitles.length >0){
        this.$store.dispatch('media/setSubtitlesAvailable', true);
      }

    },
    beforeDestroy() {
      if (this.$store.state.media.isPlaying) {
        this.$refs.mediaComp.pause();
      }
      this.removeEventHubListeners();
      this.$store.dispatch('media/setMediaControls', false);
    }
  }
</script>

<style scoped>

</style>
